import React from "react";
import { styled } from "@mui/material/styles";
import { tokens as t, JOURNEY_STEPS, journeyIndex, locationLabel } from "./tokens";

/* ---------- Status chip ---------- */
const toneMap = {
  green: { bg: t.color.greenSoft, fg: "#15803D", dot: t.color.green },
  amber: { bg: t.color.amberSoft, fg: "#B45309", dot: t.color.amber },
  slate: { bg: t.color.slateSoft, fg: "#475569", dot: t.color.slate },
  red: { bg: t.color.redSoft, fg: "#B91C1C", dot: t.color.red },
  blue: { bg: "#E8EEFB", fg: "#1D4ED8", dot: "#2563EB" },
};

const Chip = styled("span", { shouldForwardProp: (p) => p !== "tone" })(
  ({ tone = "slate" }) => {
    const c = toneMap[tone] || toneMap.slate;
    return {
      display: "inline-flex",
      alignItems: "center",
      gap: 6,
      height: 26,
      padding: "0 10px",
      borderRadius: t.radius.pill,
      fontFamily: t.font.body,
      fontSize: 11,
      fontWeight: 700,
      background: c.bg,
      color: c.fg,
      "& .dot": { width: 7, height: 7, borderRadius: "50%", background: c.dot },
    };
  }
);

export const StatusChip = ({ tone, children }) => (
  <Chip tone={tone}>
    <span className="dot" />
    {children}
  </Chip>
);

/* ---------- Signature: аяллын төлөв (journey) ---------- */
const JWrap = styled("div")({
  display: "inline-flex",
  alignItems: "center",
  fontFamily: t.font.body,
});
const Stop = styled("span", { shouldForwardProp: (p) => !["state"].includes(p) })(
  ({ state }) => ({
    width: 11,
    height: 11,
    borderRadius: "50%",
    background:
      state === "done" ? t.color.brand : state === "cur" ? t.color.amber : "#D8E0EA",
    boxShadow: state === "cur" ? `0 0 0 4px ${t.color.amberSoft}` : "none",
    flex: "none",
  })
);
const Line = styled("span", { shouldForwardProp: (p) => p !== "done" })(({ done }) => ({
  width: 26,
  height: 2.5,
  borderRadius: 2,
  background: done ? t.color.brand : "#D8E0EA",
}));
const JLabel = styled("span")({
  fontSize: 10,
  fontWeight: 600,
  color: t.color.muted,
  marginLeft: 9,
});

export const StatusJourney = ({ location, showLabel = true }) => {
  const cur = journeyIndex(location);
  return (
    <JWrap>
      {JOURNEY_STEPS.map((_, i) => (
        <React.Fragment key={i}>
          <Stop state={i < cur ? "done" : i === cur ? "cur" : "todo"} />
          {i < JOURNEY_STEPS.length - 1 && <Line done={i < cur} />}
        </React.Fragment>
      ))}
      {showLabel && <JLabel>{locationLabel(location)}</JLabel>}
    </JWrap>
  );
};

export default StatusJourney;
